import { generatePath } from 'react-router-dom';
import { Currency, formatBalance } from '@ui/src';
import ROUTES from '../../../routes';
import { RateRequest } from '../types';

const formatRateRequestList = (
  list: RateRequest[],
  currency: string,
  currencies?: Currency[],
): RateRequest[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };
    const render: Record<string, React.JSX.Element> = {};

    result.url = generatePath(ROUTES.RATE_REQUEST_EDIT, {
      currency,
      rateId: result.id,
    });

    render.exchangeCurrencyFromId = (
      <div>
        {
          currencies?.find(
            (value) => value.id === result.exchangeCurrencyFromId,
          )?.name
        }
      </div>
    );
    render.exchangeCurrencyToId = (
      <div>
        {
          currencies?.find((value) => value.id === result.exchangeCurrencyToId)
            ?.name
        }
      </div>
    );
    render.maxDeviationPercent = (
      <div>
        {formatBalance(
          Number(result.maxDeviationPercent),
          currencies?.find(
            (value) => value.id === result.exchangeCurrencyFromId,
          ),
          0,
        )}
      </div>
    );
    render.active = <div>{result?.active ? 'Active' : 'Inactive'}</div>;

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatRateRequestList;
